import { createResourceHandler } from './createResourceHandler'
import { fetchTextData } from './fetchTextData'
import { updateResourceHandler } from './updateResourceHandler'

export const methods = {
  createResource: createResourceHandler,
  fetchDataHandler: fetchTextData,
  updateResource: updateResourceHandler,
}
